const CURRENT_TENANT_UUID_STORAGE_KEY = 'currentTenantUuid';

const normalizeTenantUuid = (tenantUuid?: string | null) => {
  const normalized = tenantUuid?.trim();
  return normalized || undefined;
};

export const saveCurrentTenantUuid = (tenantUuid?: string | null) => {
  try {
    const normalizedTenantUuid = normalizeTenantUuid(tenantUuid);
    if (normalizedTenantUuid) {
      localStorage.setItem(
        CURRENT_TENANT_UUID_STORAGE_KEY,
        normalizedTenantUuid,
      );
      return;
    }
    localStorage.removeItem(CURRENT_TENANT_UUID_STORAGE_KEY);
  } catch {
    // ignore storage access errors
  }
};

export const readCurrentTenantUuid = () => {
  try {
    const tenantUuid = localStorage.getItem(CURRENT_TENANT_UUID_STORAGE_KEY);
    const normalizedTenantUuid = normalizeTenantUuid(tenantUuid);
    if (!normalizedTenantUuid) {
      localStorage.removeItem(CURRENT_TENANT_UUID_STORAGE_KEY);
      return null;
    }
    return normalizedTenantUuid;
  } catch {
    return null;
  }
};
